import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import VueScroll from './directives/VueScroll'
import VueSweetalert2 from 'vue-sweetalert2'
import Api from './plugins/api'
import Axios from './plugins/axios'
import VueCookie from 'vue-cookie'
import VueGtag from 'vue-gtag'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

Vue.directive('scroll', VueScroll)
import 'sweetalert2/dist/sweetalert2.min.css'
import { plugin } from 'postcss'
const options = {
  confirmButtonColor: 'rgb(240, 90, 26)', //replace to use css query
}
Vue.use(VueSweetalert2, options)
Vue.use(Axios)
Vue.use(Api)
Vue.use(VueCookie)
if(process.env.VUE_APP_UA_TOKEN || process.env.VUE_APP_GA4_TOKEN){
  Vue.use(VueGtag, {
    includes: [
			{ id: process.env.VUE_APP_UA_TOKEN },
			{ id: process.env.VUE_APP_GA4_TOKEN }
		]
  }, router)
}
else{console.log('no Analytics tracking')}
Vue.use(FloatingVue)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
